import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

import { AccessToken } from '../../utils/accesstoken';
import { Cookie } from '../../utils/cookie';

import { ApiBase } from './apibase.service';


export class SignIn extends ApiBase {
    constructor(protected http: Http) {
        super(http);
    }

    private createUserToken(userName: string, password: string, recaptchaToken: string): Observable<any> {
        const body = `userName=${encodeURIComponent(userName)}&password=${encodeURIComponent(password)}&grant_type=password&AppKey=A9607F64-D061-4279-8D00-F8469EA38DD1&recaptchaToken=${encodeURIComponent(recaptchaToken)}`;
        return this.http.post(this.tokenUrl, body, { headers: this.postHeaders });
    }

    post(userName: string, password: string, keepMeSignedIn: boolean, recaptchaToken: string): Observable<any> {
        return this.createUserToken(userName, password, recaptchaToken).map((r: Response) => {
            const accessToken = new AccessToken();
            const cookie = new Cookie();

            const token: any = r.json();
            accessToken.Token = token.access_token;
            accessToken.Edp = token.customerEDP;
            if (keepMeSignedIn) {
                cookie.UserAccessToken = accessToken;
            } else {
                cookie.UserAccessTokenForSession = accessToken;
            }
            cookie.UserEmail = userName;

            return token;
        });
    }
}(SignIn as any).ctorParameters = function () { return [ { type: Http } ]; }



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/service/signin.service.ts